'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

var _require = require('buffer'),
    Buffer = _require.Buffer; // @ts-ignore


var BufferList = require('bl/BufferList');

var varintEncode = require('./varint-encode');

var MIN_POOL_SIZE = 8; // Varint.encode(Number.MAX_SAFE_INTEGER).length

var DEFAULT_POOL_SIZE = 10 * 1024;
/**
 * @param {import('./types').EncoderOptions} [options]
 */

function encode(options) {
  options = options || {};
  var poolSize = Math.max(options.poolSize || DEFAULT_POOL_SIZE, options.minPoolSize || MIN_POOL_SIZE);
  var encodeLength = options.lengthEncoder || varintEncode;
  /**
   * @param {AsyncIterable<BufferList>} source
   */

  var encoder = /*#__PURE__*/function () {
    var _ref = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source) {
      var pool, poolOffset, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, chunk, encodedLength;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              pool = Buffer.alloc(poolSize);
              poolOffset = 0;
              _iteratorAbruptCompletion = false;
              _didIteratorError = false;
              _context.prev = 4;
              _iterator = _asyncIterator(source);

            case 6:
              _context.next = 8;
              return _awaitAsyncGenerator(_iterator.next());

            case 8:
              if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                _context.next = 19;
                break;
              }

              chunk = _step.value;
              encodeLength(chunk.length, pool, poolOffset);
              encodedLength = pool.slice(poolOffset, poolOffset + encodeLength.bytes);
              poolOffset += encodeLength.bytes;

              if (pool.length - poolOffset < MIN_POOL_SIZE) {
                pool = Buffer.alloc(poolSize);
                poolOffset = 0;
              }

              _context.next = 16;
              return new BufferList().append(encodedLength).append(chunk);

            case 16:
              _iteratorAbruptCompletion = false;
              _context.next = 6;
              break;

            case 19:
              _context.next = 25;
              break;

            case 21:
              _context.prev = 21;
              _context.t0 = _context["catch"](4);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 25:
              _context.prev = 25;
              _context.prev = 26;

              if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                _context.next = 30;
                break;
              }

              _context.next = 30;
              return _awaitAsyncGenerator(_iterator.return());

            case 30:
              _context.prev = 30;

              if (!_didIteratorError) {
                _context.next = 33;
                break;
              }

              throw _iteratorError;

            case 33:
              return _context.finish(30);

            case 34:
              return _context.finish(25);

            case 35:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 21, 25, 35], [26,, 30, 34]]);
    }));

    return function encoder(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return encoder;
}
/**
 * @param {BufferList | Buffer} chunk
 * @param {import('./types').EncoderOptions} [options]
 */


encode.single = function (chunk, options) {
  options = options || {};
  var encodeLength = options.lengthEncoder || varintEncode;
  return new BufferList([encodeLength(chunk.length), chunk.slice()]);
};

module.exports = encode;
module.exports.MIN_POOL_SIZE = MIN_POOL_SIZE;
module.exports.DEFAULT_POOL_SIZE = DEFAULT_POOL_SIZE;